import { Chip, Grid, TableCell, TableRow, Typography } from "@mui/material";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useAppDispatch, useAppSelector } from "../../../../app/hooks";
import { useApiFeedback } from "../../../../app/useApiFeedback";
import MessageResponse from "../../../../common/feedback/messageResponse";
import CircularLoader from "../../../../common/loaders/circularLoader";
import CustomTable from "../../../../common/tables/table";
import { SetApplicationDatesViewDto } from "../../models";
import { selectAdmin } from "../../adminSlice";
import { getApplicationDatesThunk } from "../../thunks";

const columns = [
  "#",
  "Opening Date",
  "Closing Date",
  "Alert Countdown Date",
  "Date Created",
  "User",
  "Status",
];

export default function AllApplicationDates() {
  const dispatch = useAppDispatch();
  const { feedback, handleApiResponse } = useApiFeedback();
  const adminSelect = useAppSelector(selectAdmin);
  const [rowsPerPage, setRowsPerPage] = useState<number>(5);
  const [data, setData] = useState<SetApplicationDatesViewDto[]>([]);
  const [page, setPage] = useState<number>(0);

  useEffect(() => {
    dispatch(getApplicationDatesThunk()).then((data: any) => {
      handleApiResponse(data, false);
    });
  }, []);

  useEffect(() => {
    if (adminSelect.applicationDatesState.getApplicationDates) {
      setData(adminSelect.applicationDatesState.getApplicationDates);
    }
  }, [adminSelect.applicationDatesState.getApplicationDates]);

  const createTableRows = () => {
    return (
      <>
        {(data as any)
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((record: SetApplicationDatesViewDto, key: React.Key) => {
            return (
              <TableRow key={key}>
                <TableCell>{parseInt(key.toString()) + 1}</TableCell>
                <TableCell>
                  {moment(record.openingDate).format("YYYY/MM/DD hh:mm a")}
                </TableCell>
                <TableCell>
                  {moment(record.closingDate).format("YYYY/MM/DD hh:mm a")}
                </TableCell>
                <TableCell>
                  {moment(record.alertStartDate).format("YYYY/MM/DD hh:mm a")}
                </TableCell>
                <TableCell>
                  {moment(record.createdDate).format("YYYY/MM/DD hh:mm a")}
                </TableCell>
                <TableCell>{record.user}</TableCell>

                <TableCell>
                  {record.isActive ? (
                    <Chip label="Active" sx={{ color: "green" }} />
                  ) : (
                    <Chip label="Inactive" sx={{ color: "red" }} />
                  )}
                </TableCell>
              </TableRow>
            );
          })}
      </>
    );
  };

  return (
    <>
      <MessageResponse feedback={feedback} />
      <Typography mt={2} variant="h5" gutterBottom>Application Dates History</Typography>

      <CircularLoader status={adminSelect.applicationDatesState.status} />

      {adminSelect.applicationDatesState.status === "idle" && (
        <Grid container>
          <Grid item xs={12}>
            <CustomTable
              columns={columns}
              data={data}
              rowsPerPage={rowsPerPage}
              setPage={setPage}
              setRowsPerPage={setRowsPerPage}
              rows={() => createTableRows()}
              page={page}
            />
          </Grid>
        </Grid>
      )}
    </>
  );
}
